import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, put } from '../api/client.js';

export function useUsers() {
  return useQuery({
    queryKey: ['admin', 'users'],
    queryFn: async () => (await get('/api/admin/users')).users || [],
    staleTime: 60_000,
  });
}

export function useUpdateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => put(`/api/admin/users/${id}`, body),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ['admin', 'users'] });
      if (vars?.id) qc.invalidateQueries({ queryKey: ['admin', 'users', vars.id, 'rates'] });
    },
  });
}

export function useUserRates(userId) {
  return useQuery({
    queryKey: ['admin', 'users', userId, 'rates'],
    queryFn: async () => (await get(`/api/admin/users/${userId}/rates`)).rates || [],
    enabled: !!userId,
    staleTime: 30_000,
  });
}
